import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { HiOutlineX, HiLockClosed, HiLockOpen } from "react-icons/hi";
import {
  MdOutlineAttachMoney,
  MdOutlineMoneyOff,
  MdOutlineCurrencyExchange,
} from "react-icons/md";

import { TbMessageShare } from "react-icons/tb";

import { changePasswordAdminContext } from "../../../../context/AdminContext/ChangePasswordAdminContext/ChangePasswordAdminContext";

import {
  changePasswordAdminValidation,
  confirmChangePasswordAdminValidation,
} from "../../../../utils/validation/validation";

import { defaultPicture } from "../../../../utils";
import SiteTitle from "../../../../helpers/SiteTitle/SiteTitle";
import ValidationErrorMessage from "../../../../helpers/ValidationErrorMessage/ValidationErrorMessage";
import MenuUi from "../../../../helpers/MenuUi/MenuUi";

const AdminDashboardProfile = () => {
  const userInfo = useSelector((state) => state.userInfo);

  const {
    isCodeSent,
    isOpenChangePasswordModal,
    setIsOpenChangePasswordModal,
    handleChangePassword,
    handleConfirmChangePassword,
    changePin,
    setChangePin,
    confirmChangePin,
    setConfirmChangePin,
    isOpenChangePinModal,
    setIsOpenChangePinModal,
    handleChangePin,
    pinPhoneNumber,
    setPinPhoneNumber,
    pinPassword,
    setPinPassword,
    //* Store Status
    isStoreClose,
    handleChangeStoreStatus,
    handleGetStoreStatus,
    //* Orders Status
    isOrdersClose,
    handleGetOrdersStatus,
    handleChangeOrdersStatus,
    //* Send Message By Admin
    handleSendMessageByAdmin,
    //* Orderi Status
    isOrderiClose,
    handleGetOrderiStatus,
    handleChangeOrderiStatus,
  } = useContext(changePasswordAdminContext);

  useEffect(() => {
    handleGetStoreStatus();
    handleGetOrdersStatus();
    handleGetOrderiStatus();
  }, []);

  //* Validation Change Password
  const {
    register: registerForm1,
    handleSubmit: handleSubmitForm1,
    formState: { errors: errorsForm1 },
  } = useForm({
    resolver: yupResolver(changePasswordAdminValidation),
  });

  //* Validation Confirm Change Password
  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    formState: { errors: errorsForm2 },
  } = useForm({
    resolver: yupResolver(confirmChangePasswordAdminValidation),
  });

  return (
    <>
      <SiteTitle title="پروفایل ادمین" />
      <div className="mr-auto w-full h-screen">
        <div className="flex h-full justify-center items-center rounded-xl">
          <div
            className="rounded-xl flex flex-col h-full w-full relative
            animate__animated animate__fadeIn animate__fast"
          >
            {/* Menu */}
            <MenuUi className={"top-2"} />
            <div className="absolute top-3 left-4 flex flex-col space-y-5">
              {/* Store Status */}
              <span className="cursor-pointer flex">
                {isStoreClose === true && (
                  <span onClick={() => handleChangeStoreStatus(false)}>
                    <HiLockClosed size={40} fill="#dc2626" />
                  </span>
                )}
                {isStoreClose === false && (
                  <span onClick={() => handleChangeStoreStatus(true)}>
                    <HiLockOpen size={40} fill="#16a34a" />
                  </span>
                )}
              </span>
              {/* Orders Status */}
              <span className="cursor-pointer flex">
                {isOrdersClose === false && (
                  <span onClick={() => handleChangeOrdersStatus(true)}>
                    <MdOutlineAttachMoney size={40} fill="#16a34a" />
                  </span>
                )}
                {isOrdersClose === true && (
                  <span onClick={() => handleChangeOrdersStatus(false)}>
                    <MdOutlineMoneyOff size={40} fill="#dc2626" />
                  </span>
                )}
              </span>
              {/* Send Message */}
              <span className="cursor-pointer text-gray-200">
                <TbMessageShare
                  size={40}
                  onClick={() => handleSendMessageByAdmin(false)}
                />
              </span>
              {/* Orderi Status */}
              <span className="cursor-pointer flex">
                {isOrderiClose === true && (
                  <span onClick={() => handleChangeOrderiStatus(false)}>
                    <MdOutlineCurrencyExchange size={35} fill="#dc2626" />
                  </span>
                )}
                {isOrderiClose === false && (
                  <span onClick={() => handleChangeOrderiStatus(true)}>
                    <MdOutlineCurrencyExchange size={35} fill="#16a34a" />
                  </span>
                )}
              </span>
            </div>
            {/* Information */}
            <span className="w-full h-full flex justify-center items-center">
              <div
                className="flex flex-col justify-center items-center w-full h-full p-5 space-y-5
                bg-mainBackground text-gray-200 text-xl font-medium text-center"
              >
                {/* Profile */}
                <span className="xl:w-[30%] md:w-[60%] w-full">
                  <img
                    src={defaultPicture}
                    alt="User_Profile"
                    width={135}
                    className="m-auto text-white rounded-full object-cover"
                  />
                </span>
                {/* User Name */}
                <span
                  className="xl:w-[30%] md:w-[60%] w-full p-2 space-y-2
                      flex flex-col justify-between
                      border-2 border-boxColor bg-boxColor rounded-xl"
                >
                  <span>نام کاربر :</span>
                  <span>
                    {userInfo[0]?.firstname} {userInfo[0]?.lastname}
                  </span>
                </span>
                {/* Phone Number */}
                <span
                  className="xl:w-[30%] md:w-[60%] w-full p-2 space-y-2
                      flex flex-col justify-between
                      border-2 border-boxColor bg-boxColor rounded-xl"
                >
                  <span>موبایل :</span>
                  <span>{userInfo[0]?.phonenumber}</span>
                </span>
                {/* National Number */}
                <span
                  className="xl:w-[30%] md:w-[60%] w-full p-2 space-y-2
                      flex flex-col justify-between
                      border-2 border-boxColor bg-boxColor rounded-xl"
                >
                  <span>کد ملی :</span>
                  <span>{userInfo[0]?.nationalid}</span>
                </span>
                {/* Forget Password Button */}
                <span
                  onClick={() => setIsOpenChangePasswordModal(true)}
                  className="xl:w-[30%] md:w-[60%] w-full p-2
                bg-green-500 hover:bg-green-600 
                  hover:transition-all hover:duration-150 hover:ease-linear
                  transition-all duration-150 ease-linear
                  cursor-pointer rounded-lg text-slate-900"
                >
                  <button>تغییر رمز عبور</button>
                </span>
                {/* Forget Pin Button */}
                <span
                  onClick={() => setIsOpenChangePinModal(true)}
                  className="xl:w-[30%] md:w-[60%] w-full p-2
                bg-green-500 hover:bg-green-600 
                  hover:transition-all hover:duration-150 hover:ease-linear
                  transition-all duration-150 ease-linear
                  cursor-pointer rounded-lg text-slate-900"
                >
                  <button>تغییر پین</button>
                </span>
              </div>
            </span>
          </div>
          {/* Forget Password Modal */}
          {isOpenChangePasswordModal && (
            <>
              <div
                className="flex absolute bg-black bg-opacity-40 
                inset-0 h-screen items-center w-full z-50 mr-auto 
                animate__animated animate__fadeIn animate__fast"
              >
                <div
                  className="flex flex-col lg:-mt-0 -mt-24 w-11/12 sm:w-5/6
               lg:w-12/12 max-w-2xl mx-auto rounded-lg border-2 border-modalColor"
                >
                  <div className="flex flex-row justify-between p-5 bg-modalColor">
                    {/* Title - Close Icon */}
                    <span className="flex justify-between w-full text-gray-200">
                      {/* Title */}
                      <span>
                        <p className="font-semibold">تغییر رمز عبور</p>
                      </span>
                      {/* Close Icon */}
                      <span>
                        <HiOutlineX
                          size={25}
                          onClick={() => setIsOpenChangePasswordModal(false)}
                          className="cursor-pointer"
                        />
                      </span>
                    </span>
                  </div>
                  <span className="border-b-2 border-headerLineModal" />
                  {/* Inputs */}
                  <div className="w-full px-6 py-5 bg-modalColor">
                    {/* First Form */}
                    {!isCodeSent && (
                      <>
                        <form
                          onSubmit={handleSubmitForm1(handleChangePassword)}
                        >
                          <div className="grid grid-cols-1 gap-x-3 w-full">
                            <span className="animate__animated animate__fadeIn animate__fast">
                              {/* Phone Number */}
                              <span>
                                <label
                                  htmlFor="phonenumber"
                                  className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                >
                                  شماره موبایل
                                </label>
                                <input
                                  type="text"
                                  name="phonenumber"
                                  placeholder="شماره موبایل"
                                  autoComplete="off"
                                  {...registerForm1("phonenumber")}
                                  className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                                />
                                <span>
                                  <ValidationErrorMessage
                                    message={errorsForm1.phonenumber?.message}
                                  />
                                </span>
                              </span>
                              {/* Current password */}
                              <span>
                                <label
                                  htmlFor="currentPassword"
                                  className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                >
                                  رمز عبور فعلی
                                </label>
                                <input
                                  type="text"
                                  name="currentPassword"
                                  placeholder="رمز عبور فعلی"
                                  autoComplete="off"
                                  {...registerForm1("currentPassword")}
                                  className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                                />
                                <span>
                                  <ValidationErrorMessage
                                    message={
                                      errorsForm1.currentPassword?.message
                                    }
                                  />
                                </span>
                              </span>
                            </span>
                          </div>
                          {/* Button */}
                          <div className="flex items-center justify-end p-5 w-full">
                            <button
                              type="submit"
                              className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                            >
                              دریافت کد
                            </button>
                          </div>
                        </form>
                      </>
                    )}
                    {/* Second Form */}
                    {isCodeSent && (
                      <form
                        onSubmit={handleSubmitForm2(
                          handleConfirmChangePassword
                        )}
                      >
                        <div className="grid grid-cols-1 gap-x-3 w-full">
                          <>
                            <span className="animate__animated animate__fadeIn animate__fast">
                              {/* New Password */}
                              <span>
                                <label
                                  htmlFor="newPassword"
                                  className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                >
                                  رمز عبور جدید
                                </label>
                                <input
                                  type="text"
                                  name="newPassword"
                                  placeholder="رمز عبور جدید"
                                  autoComplete="off"
                                  {...registerForm2("password")}
                                  className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                                />
                                <span>
                                  <ValidationErrorMessage
                                    message={errorsForm2.password?.message}
                                  />
                                </span>
                              </span>
                              {/* Confirm New password */}
                              <span>
                                <label
                                  htmlFor="confirmPassword"
                                  className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                >
                                  تکرار رمز عبور جدید
                                </label>
                                <input
                                  type="text"
                                  name="confirmPassword"
                                  placeholder="تکرار رمز عبور جدید"
                                  autoComplete="off"
                                  {...registerForm2("confirmpassword")}
                                  className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                                />
                                <span>
                                  <ValidationErrorMessage
                                    message={
                                      errorsForm2.confirmpassword?.message
                                    }
                                  />
                                </span>
                              </span>
                              {/* Verify Code */}
                              <span>
                                <label
                                  htmlFor="verifyCode"
                                  className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                >
                                  کد تأیید
                                </label>
                                <input
                                  type="text"
                                  name="verifyCode"
                                  placeholder="کد تأیید"
                                  autoComplete="off"
                                  {...registerForm2("token")}
                                  className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400 text-center
                                  focus:border-gray-200 focus:text-gray-200"
                                />
                                <span>
                                  <ValidationErrorMessage
                                    message={errorsForm2.token?.message}
                                  />
                                </span>
                              </span>
                            </span>
                          </>
                        </div>
                        {/* Button */}
                        <div className="flex items-center justify-end p-5 w-full">
                          <button
                            type="submit"
                            className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                          >
                            تغییر رمز عبور
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          {/* Forget Pin Modal */}
          {isOpenChangePinModal && (
            <>
              <div
                className="flex absolute bg-black bg-opacity-40 
                inset-0 h-screen items-center w-full z-50 mr-auto 
                animate__animated animate__fadeIn animate__fast"
              >
                <div
                  className="flex flex-col lg:-mt-0 -mt-24 w-11/12 sm:w-5/6
               lg:w-12/12 max-w-2xl mx-auto rounded-lg border-2 border-modalColor"
                >
                  <div className="flex flex-row justify-between p-5 bg-modalColor">
                    {/* Title - Close Icon */}
                    <span className="flex justify-between w-full text-gray-200">
                      {/* Title */}
                      <span>
                        <p className="font-semibold">تغییر پین</p>
                      </span>
                      {/* Close Icon */}
                      <span>
                        <HiOutlineX
                          size={25}
                          onClick={() => setIsOpenChangePinModal(false)}
                          className="cursor-pointer"
                        />
                      </span>
                    </span>
                  </div>
                  <span className="border-b-2 border-headerLineModal" />
                  {/* Inputs */}
                  <div className="w-full px-6 py-5 bg-modalColor">
                    <form onSubmit={handleChangePin}>
                      <div className="grid grid-cols-1 gap-x-3 w-full">
                        <span className="animate__animated animate__fadeIn animate__fast">
                          {/* Phone Number */}
                          <span>
                            <label
                              htmlFor="phonenumber"
                              className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                            >
                              شماره موبایل
                            </label>
                            <input
                              type="text"
                              name="phonenumber"
                              placeholder="شماره موبایل"
                              autoComplete="off"
                              value={pinPhoneNumber}
                              onChange={(e) =>
                                setPinPhoneNumber(e.target.value)
                              }
                              className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                            />
                          </span>
                          {/* New Pin */}
                          <span>
                            <label
                              htmlFor="newPin"
                              className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                            >
                              پین جدید
                            </label>
                            <input
                              type="text"
                              name="newPin"
                              placeholder="پین جدید"
                              autoComplete="off"
                              value={changePin}
                              onChange={(e) => setChangePin(e.target.value)}
                              className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                            />
                          </span>
                          {/* Confirm New Pin */}
                          <span>
                            <label
                              htmlFor="confirmPin"
                              className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                            >
                              تکرار پین جدید
                            </label>
                            <input
                              type="text"
                              name="confirmPin"
                              placeholder="تکرار پین جدید"
                              autoComplete="off"
                              value={confirmChangePin}
                              onChange={(e) =>
                                setConfirmChangePin(e.target.value)
                              }
                              className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                            />
                          </span>
                          {/* Password */}
                          <span>
                            <label
                              htmlFor="password"
                              className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                            >
                              رمز عبور
                            </label>
                            <input
                              type="text"
                              name="password"
                              placeholder="رمز عبور"
                              autoComplete="off"
                              value={pinPassword}
                              onChange={(e) => setPinPassword(e.target.value)}
                              className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                            />
                          </span>
                        </span>
                      </div>
                      {/* Button */}
                      <div className="flex items-center justify-end p-5 w-full">
                        <button
                          type="submit"
                          className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                        >
                          تغییر پین
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AdminDashboardProfile;
